// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__x2X54","description":"PatientConsentPreview_description__31oD8"};